<template>
  <section>

    <div v-if="itemView">
      <div class="panel-title" :class="itemView.PanelClass || 'panel-title'">
        <a :data-parent="'#' + accordionParentName" data-toggle="collapse" :href="'#accordionItem' + itemView.ID"
          aria-expanded="false">
          <span class="open-sub"></span>
          {{ itemView.Title }}
        </a>
      </div>

      <div :id="'accordionItem' + itemView.ID" class="panel-collapse collapse" role="tablist" aria-expanded="false">
        <div class="panel-content">
          <div class="item" v-if="itemView.Obj">
            <div class="row">
              <div class="col-md-12">
                <div class="font-18 mt-0 mb-30 no-style notranslate">
                  <vue-markdown :name="'markdown' + itemView.Obj.id" class="markdownVideoLink"
                    :source="itemView.Obj.Description"></vue-markdown>


                  <h4 class="mt-30" v-if="canIAddResult()">Risultati: </h4>
                  <div v-if="getUserTracks().length > 0 && canIAddResult()">

                    <div v-for="userTrack in getUserTracks()" :key="userTrack.Id">
                      <p><b>Tempo:</b> {{ userTrack.Time }}</p>

                      <b>Informazioni:</b>

                      <ul v-for="load in userTrack.LoadList" :key="load.Id">
                        <li>{{ load.Type }}: {{ load.Value }}</li>
                      </ul>

                      <p><b>Sensazioni:</b> {{ userTrack.Improvments }}</p>


                      <p><b>Movimenti difficili:</b> {{ userTrack.Difficulties }}</p>
                    </div>
                  </div>

                  <p v-if="getUserTracks().length == 0 && canIAddResult()">Nessun risultato salvato.</p>

                  <button v-if="canIAddResult() && getUserTracks().length == 0" type="submit" v-on:click="editUserTrack"
                    class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white">
                    Salva risultati
                  </button>

                  <button v-if="canIAddResult() && getUserTracks().length > 0" type="submit" v-on:click="editUserTrack"
                    class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white">
                    Modifica risultati
                  </button>
                </div>
              </div>
              <div class="col-md-6" v-if="itemView.Obj.Gallery != null && itemView.Obj.Gallery.length > 0">
                <h5 class="text-uppercase mt-0 mb-10 letter-space-2">
                  Galleria:
                </h5>
                <div class="gallery-isotope grid-2 gutter-small clearfix" data-lightbox="gallery">
                  <div class="gallery-item" v-for="(img, index) in itemView.Obj.Gallery" :key="img.id">
                    <a :href="baseUrl + img.url" :title="'Immagine - ' + (index + 1)" data-lightbox="gallery-item">
                      <img :src="baseUrl + img.url" :alt="img.alternativeText" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-6" v-if="itemView.Obj.Videos != null && itemView.Obj.Videos.length > 0">
                <h5 class="text-uppercase mt-0 mb-10 letter-space-2">Video:</h5>
                <div class="row">
                  <div class="col-md-12" v-for="(vid, index) in itemView.Obj.Videos" :key="vid.id">
                    <video preload="metadata" width="100%" controls :title="'Video - ' + (index + 1)">
                      <source :src="baseUrl + vid.url" :type="vid.mime" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div :id="'secondLevel' + itemView.ID" v-if="itemView.Items" class="panel-group accordion">
            <div class="panel" v-for="item in itemView.Items" :key="item.ID">
              <program-detail-item :name="'thirthLevel' + item.ID" v-bind:itemView="item" v-bind:userTracks="userTracks"
                v-bind:idProgramDetail="idProgramDetail" @reload="reloadItem"
                v-bind:accordionParentName="'secondLevel' + itemView.ID" />
            </div>
          </div>
        </div>
      </div>

    </div>

    <user-track-modal v-bind:userTrack="userTrackToSave" v-bind:addTrack="addTrackModalOpen"
      v-on:closeModal="addTrackModalOpen = false" @submit="handleFormSubmit" />
  </section>
</template>

<style scoped>
.sub-panel-title a {
  color: #ee163b;
}

.thirth-panel-title a {
  color: #b3b3b3;
}
</style>

<script>
import VueMarkdown from "vue-markdown";
import axios from "axios";
import UserTrackModal from "../../components/UserTrackModal.vue";
import ProgramDetailItem from "../auth/ProgramDetailItem.vue";
export default {
  name: "program-detail-item",
  props: ["itemView", "accordionParentName", "userTracks", "idProgramDetail"],
  components: {
    VueMarkdown,
    UserTrackModal,
    ProgramDetailItem
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      userTrackToSave: null,
      addTrackModalOpen: false,
    };
  },
  methods: {
    reloadItem() {
      this.$emit("reload");
    },
    getUserTracks() {
      return this.userTracks.filter(x => x.IdProgramDetailItem == this.itemView.Obj.id);
    },
    canIAddResult() {
      // console.log(this.itemView.Title);

      if (this.itemView.Title.toLowerCase().trim() == "INIZIAMO-WARM UP".toLowerCase()) {
        return false;
      }
      if (this.itemView.Title.toLowerCase().trim() == "GLOSSARIO".toLowerCase()) {
        return false;
      }
      if (this.itemView.Title.toLowerCase().trim() == "Tips Alimentari".toLowerCase()) {
        return false;
      }

      return true;

    },
    editUserTrack() {
      this.addTrackModalOpen = true;
      this.userTrackToSave = this.userTracks.filter(x => x.IdProgramDetailItem == this.itemView.Obj.id)[0];
    },
    handleFormSubmit($event) {
      var itemTOSend = {
        IdProgramDetailItem: this.itemView.Obj.id,
        IdProgramDetail: this.idProgramDetail,
        Time: $event.Time,
        Improvments: $event.Improvments,
        Difficulties: $event.Difficulties,
        LoadList: $event.LoadList,
      }

      axios
        .post(process.env.VUE_APP_API_URL + "/userprogress/insertUpdate", itemTOSend)
        .then(() => { this.$emit("reload"); });



    }
  },
};
</script>
